import { render, staticRenderFns } from "./StParticulateMatter.vue?vue&type=template&id=321ddab4"
import script from "./StParticulateMatter.vue?vue&type=script&lang=ts"
export * from "./StParticulateMatter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports